import { render, staticRenderFns } from "./TextareaEditor.vue?vue&type=template&id=1826bde2"
import script from "./TextareaEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./TextareaEditor.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1826bde2')) {
      api.createRecord('1826bde2', component.options)
    } else {
      api.reload('1826bde2', component.options)
    }
    module.hot.accept("./TextareaEditor.vue?vue&type=template&id=1826bde2", function () {
      api.rerender('1826bde2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/forms/TextareaEditor.vue"
export default component.exports